/**
 * An object representing different authentication policies.
 * 
 * @constant {object} AUTH_POLICY
 * @property {string} NOT_ALLOWED - This auth policy type indicates that authentication is not allowed. Only unauthenticated users can access.
 * @property {string} REQUIRED - This auth policy type indicates that authentication is required. Only logged-in users can access.
 * @property {string} NOT_ENFORCED - This auth policy type indicates that authentication is not enforced. Everyone has access.
 */
const AUTH_POLICY = Object.freeze({
    NOT_ALLOWED: 'NOT_ALLOWED',
    REQUIRED: 'REQUIRED',
    NOT_ENFORCED: 'NOT_ENFORCED'
});

export default AUTH_POLICY;